{
  "version": 1,
  "asset_id": "11fe389d-bf84-4528-97b1-c997c9c5cf24",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/11fe389d-bf84-4528-97b1-c997c9c5cf24/swatch-tan.jpeg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/11fe389d-bf84-4528-97b1-c997c9c5cf24/swatch-tan.jpeg",
  "original_filename": "swatch-tan.jpeg",
  "size": 434947,
  "content_type": "image/jpeg",
  "created_at": "2026-08-02T15:18:13Z"
}
